import React, { ForwardedRef, forwardRef } from "react"
import { UnstyledButton } from "@mantine/core"

import { Icon } from "@/components"

import { useStyles } from "@/components/TopNavigation/components/RegionSelector/Target/Target.styles"

type TargetProps = {
    currentRegionName: string
    isOpen: boolean
    loggedInAsUser: boolean
    onClick: () => void
    popdownIsOpen: boolean
}

export const Target = forwardRef(
    (
        { currentRegionName, isOpen, loggedInAsUser, popdownIsOpen, onClick }: TargetProps,
        ref: ForwardedRef<HTMLButtonElement>,
    ) => {
        loggedInAsUser = loggedInAsUser || Boolean(Userdata.logged_in_as_user_from_regular_user)
        const { classes } = useStyles({ isOpen, loggedInAsUser, popdownIsOpen })

        return (
            <UnstyledButton type="button" onClick={onClick} className={classes.target} ref={ref}>
                <Icon icon="globe" className="region-button--globe-icon" />
                <span className="region-button--name">{currentRegionName}</span>
                <Icon icon={isOpen ? "angle-up" : "angle-down"} className="region-button--angle-icon" />
            </UnstyledButton>
        )
    },
)
